<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="mt-6">
        <v-form ref="upload" @submit.prevent="save_data">
          <v-card elevation="6">
            <div class="pa-3">
              <div class="pa-4">
                <span style="font-size: 24px">การสร้างรอบนับสต๊อก</span>
              </div>
              <!-- Mobile -->
              <div class="ml-6 d_mobile">
                <div class="ml-1">รอบนับครั้งที่ {{ save_count_stock.count }}</div>
              </div>
              <div class="ml-6 mt-6 mr-6 d_mobile">
                <div class="ml-1 mb-2">วันที่นับสต๊อก</div>
                <v-menu ref="menu_date_mobile" v-model="menu_date_mobile" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field color="#86bc3a" clearable class="input_width" v-model="save_count_stock.date" :rules="[v => !!v || 'กรุณากรอกวันที่นับสต๊อก']" label="วันที่นับสต๊อก (วัน/เดือน/ปี)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(temp_date)" v-model="temp_date" :min="max_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDateMobile()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_date_mobile = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="d_mobile">
                <div class="ml-6">
                  <div class="ml-1 mb-2">ผู้นับสต๊อก</div>
                </div>
                <div v-if="emp_lists.length > 0 " class="grid_checkbox mb-6" style="margin-left: 15%">
                  <div class="d-flex align-center" v-for="(count, index) in emp_lists" :key="index">
                    <v-checkbox class="ma-0" color="#86bc3a" hide-details="auto" v-model="count.checkbox"></v-checkbox>
                    <div>
                      {{ count.username }}
                    </div>
                  </div>
                </div>
                <div v-else class="grid_checkbox mb-6" style="margin-left: 9%">
                  <div class="d-flex align-center grey--text">ไม่พบผู้นับสต๊อก</div>
                </div>
              </div>
              <div class="d_mobile mb-6">
                <div class="ml-6">
                  <div class="ml-1">คลัง</div>
                </div>
                <div class="ml-6 mr-6 mt-2">
                  <div class="d-flex">
                    <v-autocomplete class="input_width" color="#86bc3a" :rules="[v => !!v || 'กรุณาเลือกคลัง']" :items="items" item-text="name" item-value="id" v-model="save_count_stock.stock_id" prepend-inner-icon="mdi-package-variant-closed" label="คลัง" hide-details="auto" outlined></v-autocomplete>
                  </div>
                </div>
              </div>
              <div class="d_mobile">
                <div class="ml-6">
                  <div class="ml-1">หมายเหตุ</div>
                </div>
                <div class="ml-6 mr-6 mt-2">
                  <v-text-field color="#86bc3a" class="input_width" label="หมายเหตุ" hide-details="auto" v-model="save_count_stock.note" outlined></v-text-field>
                </div>
              </div>
              <div class="ma-6 d_mobile">
                <div class="ml-1">ผู้สร้างรอบนับ</div>
                <div class="ma-2">{{ $store.state.userDetail.name }}</div>
              </div>
              <!-- PC & Tablet -->
              <div class="mb-6 grid_row">
                <div class="ma-6">
                  <div class="ml-1">รอบนับครั้งที่</div>
                </div>
                <div class="mt-6 mr-1">
                  <div>{{ save_count_stock.count }}</div>
                </div>
              </div>
              <div class="grid_row">
                <div class="ma-6">
                  <div class="ml-1">วันที่นับสต๊อก</div>
                </div>
                <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field color="#86bc3a" clearable class="input_width" v-model="save_count_stock.date" :rules="[v => !!v || 'กรุณากรอกวันที่นับสต๊อก']" label="วันที่นับสต๊อก (วัน/เดือน/ปี)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(temp_date)" v-model="temp_date" :min="max_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="mb-6 grid_header">
                <div class="ma-6">
                  <div class="ml-1">ผู้นับสต๊อก</div>
                </div>
                <div class="grid_checkbox" v-if="emp_lists.length > 0">
                  <div class="d-flex align-center" v-for="(count, index) in emp_lists" :key="index">
                    <v-checkbox class="ma-0" color="#86bc3a" hide-details="auto" v-model="count.checkbox"></v-checkbox>
                    <div>{{ count.name }}</div>
                  </div>
                </div>
                <div class="grid_checkbox" v-else>
                  <div class="d-flex align-center grey--text">ไม่พบผู้นับสต๊อก</div>
                </div>
              </div>
              <div class="mb-6 grid_row">
                <div class="ma-6">
                  <div class="ml-1">คลัง</div>
                </div>
                <div class="mt-3 mr-1">
                  <v-autocomplete class="input_width" color="#86bc3a" :rules="[v => !!v || 'กรุณาเลือกคลัง']" :items="items" item-text="name" item-value="id" v-model="save_count_stock.stock_id" prepend-inner-icon="mdi-package-variant-closed" label="คลัง" hide-details="auto" outlined></v-autocomplete>
                </div>
              </div>
              <div class="mb-6 grid_row">
                <div class="ma-6">
                  <div class="ml-1">หมายเหตุ</div>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" class="input_width" label="หมายเหตุ" hide-details="auto" v-model="save_count_stock.note" outlined></v-text-field>
                </div>
              </div>
              <div class="mb-6 grid_row">
                <div class="ma-6">
                  <div class="ml-1">ผู้สร้างรอบนับ</div>
                </div>
                <div class="mt-6 mr-1 ">
                  {{ $store.state.userDetail.name }}
                </div>
              </div>
              <div class="ma-2 text-right" v-if="emp_lists.length > 0">
                <v-btn class="pa-6 grad-success-bg white--text btn_mobile" type="submit" :disabled="check_btn">บันทึก</v-btn>
              </div>
              <div class="ma-2 text-right" v-else>
                <v-btn class="pa-6 grad-grey-bg white--text btn_mobile" :disabled="!check_btn">บันทึก</v-btn>
              </div>
            </div>
            <v-overlay :value="overlay" class="z_index">
              <div class="text-center">
                <v-progress-circular
                    indeterminate
                    size="70"
                    width="7"
                    color="#86bc3a"
                ></v-progress-circular>
                <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
              </div>
            </v-overlay>
          </v-card>
        </v-form>
        <v-dialog v-model="image_modal" max-width="900">
          <v-card elevation="0">
            <div class="d-flex justify-end">
              <v-btn icon class="ma-4" @click="image_modal = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-img :src="img_barcode"></v-img>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import img_barcode from "@/assets/image_barcode.jpeg";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Warehouse_Create",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      name: null,
      date: null,
      temp_date: '',
      start_date: this.minDate(),
      menu_date: null,
      img_barcode: img_barcode,
      menu_date_mobile: null,
      image_modal: false,
      check_btn: false,
      loading_page: false,
      overlay: false,
      save_count_stock: {
        count: 0,
        date: null,
        file_csv: null,
        note: null,
        stock_id: null,
      },
      items: [
        {id: 1, name: 'คลังหลัก'},
        {id: 2, name: 'คลังใกล้หมดอายุ'},
        {id: 3, name: 'คลังชำรุด'},
        {id: 4, name: 'คลังรอคืน'},
        {id: 5, name: 'คลังรอลดหนี้'},
        {id: 6, name: 'คลังทิ้ง'},
        {id: 7, name: 'คลังโปรโมชั่น'},
      ],
      emp_lists: [],
      employee_save: [],
    }
  },
  methods: {
    minDate() {
      const today = new Date();
      let month = today.getMonth() + 1;
      let date = today.getDate();
      if (month < 10){
        month = '0'+ month
      }
      if (date < 10){
        date = '0'+ date
      }
      const result_date = today.getFullYear()+'-'+month+'-'+date;
      return result_date;
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.save_count_stock.date = final_date
    },
    diffDateEN() {
      const diff = this.save_count_stock.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    async selectDateMobile() {
      this.$refs.menu_date_mobile.save(this.date)
      this.menu_date_mobile = false
    },
    generate_id() {
      this.loading_page = true
      HTTP.post('/inventory/counts/getlastround')
          .then((res) => {
            this.loading_page = false
            this.save_count_stock.count = res.data.stock_name
            this.emp_lists = res.data.users
            this.emp_lists.forEach((datalist, index) => {
              this.emp_lists[index].checkbox = false;
            });
          })
    },
    save_data() {
      if (this.$refs.upload.validate()) {
        this.overlay = true;
        let get_data = this.emp_lists.filter((data) => {
          return data.checkbox === true
        })
        let data_filter = get_data.map(data => data.id);
        if (data_filter !== null && data_filter.length > 0) {
          if (this.temp_date !== '' || this.temp_date !== null && data_filter.status === true) {
            this.check_btn = true
            HTTP.post('/inventory/counts/create', {
              count: this.save_count_stock.count,
              date: this.diffDateEN(),
              emp_lists: data_filter,
              user_create: this.$store.state.userDetail.id,
              username: this.$store.state.userDetail.name,
              note: this.save_count_stock.note,
              warehouse_type: this.save_count_stock.stock_id,
            }).then((res) => {
                  if (res.data.success === true) {
                    this.check_btn =  false
                    this.overlay = false
                    Swal.fire({
                      title: 'บันทึกข้อมูลเรียบร้อย',
                      icon: 'success',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: `ตกลง`,
                      denyButtonText: `ยกเลิก`,
                    }).then(() => {
                      if (this.$store.state.userDetail.count_warehouse === 1) {
                        this.$router.push('/stock/count_warehouse/countlistwarehouse')
                      }else {
                        this.$router.push('/stock');
                      }
                    })
                  }
                })
          }
          else {
            this.overlay = false;
            Swal.fire({
              title: 'กรุณาตรวจสอบข้อมูล !',
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        }
        else {
          this.overlay = false;
          Swal.fire({
            title: 'กรุณาเลือกผู้นับสต๊อก !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
    },
  },
  computed: {
    max_date() {
      const dateTodayList = new Date();
      let date_month = dateTodayList.getMonth() + 1
      if (date_month < 10) {
        date_month = '0' + date_month
      }
      let date_day = dateTodayList.getDate()
      if (date_day < 10) {
        date_day = '0' + date_day
      }
      const date_today = dateTodayList.getFullYear() + '-' + date_month + '-' + date_day
      return date_today
    },
    // rules() {
    //   const data_list = this.emp_lists
    //   return [
    //     data_list.forEach((data) => {
    //       data.checkbox.length > 0 || "ควรเลือกอย่างน้อยหนึ่งรายการ"
    //     })
    //   ]
    // }
  },
  beforeMount() {
    this.generate_id();
  },
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.grid_row {
  display: grid;
  grid-template-columns: 20% 80%;
  grid-gap: 15px 0;
}
.grid_header {
  display: grid;
  grid-template-columns: 20% 80%;
  grid-gap: 15px 0;
}
.grid_checkbox {
  display: grid;
  grid-template-columns: 20% 20% 20% 20%;
  grid-gap: 15px 0;
}
.input_width {
  width: 40% !important;
}
.margin_input {
  margin-right: 54%;
}
.d_mobile {
  display: none;
}
.btn_mobile {
  font-size: 20px;
  width: 30%;
}
@media only screen and (max-width: 1180px) {
  .grid_row {
    display: grid;
    grid-template-columns: 30% 70%;
    grid-gap: 15px 0;
  }
  .grid_header {
    display: grid;
    grid-template-columns: 30% 70%;
    grid-gap: 15px 0;
  }
  .grid_checkbox {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .input_width {
    width: 60% !important;
  }
  .margin_input {
    margin-right: 30%;
  }
}
@media only screen and (max-width: 500px) {
  .d_mobile {
    display: grid;
  }
  .btn_mobile {
    font-size: 20px;
    width: 100%;
  }
  .grid_row {
    display: none;
    /*grid-template-columns: 45% 55%;*/
  }
  .grid_header {
    display: none;
    /*grid-template-columns: 45% 55%;*/
  }
  .grid_checkbox {
    display: grid;
    grid-template-columns: 100%;
  }
  .input_width {
    width: 100% !important;
  }
  .margin_input {
    margin-right: 100%;
  }
}
</style>
